import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { isError, isLoaded } from 'src/app/shared/utils/async';

import type { RootShareRecommendations } from '../useFetchShareRecommendations';
import { useFetchShareRecommendations } from '../useFetchShareRecommendations';

export type Recommendation = NonNullable<
	NonNullable<RootShareRecommendations['facebook'] | RootShareRecommendations['reddit']>[0]
>;
type UseShareRecommendationsReturn = ModelHookResult<{
	shareRecommendations: RootShareRecommendations;
	shouldDisplayShareRecommendations: boolean;
	shareRecommendationsLoading: boolean;
}>;

export const EMPTY_SHARE_RECOMMENDATIONS: RootShareRecommendations = {
	facebook: [],
	reddit: [],
};

export function useShareRecommendations(slug: string): UseShareRecommendationsReturn {
	const {
		data: {
			petition: {
				country: { countryCode: petitionCountryCode },
			},
		},
	} = useStarterDashboardV2PageData();

	// Only fetch recommendations for US petitions
	const fetchEnabled = petitionCountryCode === 'US';

	const shareRecommendationsResult = useFetchShareRecommendations(slug, fetchEnabled);
	const shareRecommendations = isLoaded(shareRecommendationsResult)
		? shareRecommendationsResult.data
		: EMPTY_SHARE_RECOMMENDATIONS;
	const hasAnyShareRecommendations = !!shareRecommendations.reddit.length || !!shareRecommendations.facebook.length;
	const shareRecommendationsLoading =
		fetchEnabled && !isLoaded(shareRecommendationsResult) && !isError(shareRecommendationsResult);

	return {
		data: {
			shareRecommendations,
			shouldDisplayShareRecommendations: hasAnyShareRecommendations,
			shareRecommendationsLoading,
		},
	};
}
